import { createStyles } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles';

const BORDER_WIDTH = 2;

export const outlinedSecondaryStyles = (
  gradient: string,
  layoutBackgroundPrimaryColor: string,
  isCssFunc?: boolean,
) => ({
  borderWidth: BORDER_WIDTH,
  borderColor: 'transparent',
  backgroundImage: `linear-gradient(${layoutBackgroundPrimaryColor}, ${layoutBackgroundPrimaryColor}),
  ${isCssFunc ? gradient : `linear-gradient(to right, ${gradient}, ${gradient})`}`,
});

const styles = ({
  colors,
  spacing,
  typography,
  flags,
}: Theme) => createStyles({
  root: {
    ...typography.textSmall,
    textTransform: 'none',
    borderRadius: spacing(5),
    boxShadow: 'none',
  },
  label: {},
  containedPrimary: {
    padding: 0,
    backgroundColor: colors.controls.button.primary.enabled.fill,
    color: colors.controls.button.primary.enabled.name,
    transition: 'background-color 1000ms ease-in',
    '& $label': {
      padding: `${spacing(1)}px ${spacing(3)}px`,
    },
    '&:hover': {
      background: colors.controls.button.primary.hovered.fill,
      color: colors.controls.button.primary.hovered.name,
      boxShadow: 'none',
      transition: 'background 1000ms ease-in',
    },
    '&:disabled': {
      color: colors.controls.button.primary.disabled.name,
      backgroundColor: colors.controls.button.primary.disabled.fill,
    },
    '&:active:not([disabled])': {
      background: colors.controls.button.primary.pressed.fill,
      color: colors.controls.button.primary.pressed.name,
      transition: 'background-color 1000ms ease-in',
    },
  },
  outlinedSecondary: {
    padding: 0,
    color: colors.controls.button.secondary.enabled.name,
    borderColor: colors.controls.button.secondary.enabled.stroke,
    backgroundOrigin: 'border-box',
    borderWidth: BORDER_WIDTH,
    '& $label': {
      ...typography.accentSmall,
      padding: `${spacing(1) - BORDER_WIDTH}px ${spacing(3) - BORDER_WIDTH}px`,
      backgroundColor: colors.layout.backgroundPrimary,
      borderRadius: spacing(5),
    },
    '&:hover': {
      color: colors.controls.button.secondary.hovered.name,
      borderColor: flags.boxStyle === 'full' ? colors.controls.button.secondary.hovered.stroke : 'transparent',
      backgroundImage: flags.boxStyle === 'stroke' ? colors.controls.button.secondary.hovered.stroke : 'none',
      backgroundColor: flags.boxStyle === 'full'
        ? colors.controls.button.secondary.hovered.fill
        : colors.layout.backgroundPrimary,
      borderWidth: BORDER_WIDTH,
      '& $label': {
        backgroundColor: flags.boxStyle === 'full'
          ? colors.controls.button.secondary.hovered.fill
          : colors.layout.backgroundPrimary,
      },
    },
    '&:disabled': {
      color: colors.controls.button.secondary.disabled.name,
    },
    '&:active:not([disabled])': {
      borderColor: colors.controls.button.secondary.pressed.stroke,
      backgroundColor: flags.boxStyle === 'full'
        ? colors.controls.button.secondary.pressed.fill
        : colors.layout.backgroundPrimary,
    },
  },
  sizeSmall: {
    ...typography.textTiny,
    '& $label': {
      padding: `${spacing(0.5)}px ${spacing(2)}px`,
    },
  },
  sizeLarge: {
    ...typography.h6,
    '& $label': {
      padding: `${spacing(2)}px ${spacing(4)}px`,
    },
  },
  outlinedSizeSmall: {
    '& $label': {
      ...typography.textTiny,
      padding: `${spacing(0.5) - BORDER_WIDTH}px ${spacing(2) - BORDER_WIDTH}px`,
    },
  },
  outlinedSizeLarge: {
    '& $label': {
      ...typography.h6,
      padding: `${spacing(2) - BORDER_WIDTH}px ${spacing(4) - BORDER_WIDTH}px`,
    },
  },
  text: {
    padding: 0,
    borderRadius: 0,
    '&:hover': {
      backgroundColor: colors.uIBlueBackground,
    },
  },
  iconSizeSmall: {
    '&:hover': {
      backgroundColor: colors.layoutBackgroundPrimary,
      textDecoration: 'underline',
      textUnderlinePosition: 'under',

      '& path': {
        fill: colors.uIBase,
        fillOpacity: 1,
      },
    },
  },
});

export default styles;
